import React from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import Card from '../components/Card';
import type { PlanFeatureKey } from '../organization/PricingConfig';
import PricingModalButton from '../organization/PricingModalButton';
import UpgradeBadge from '../organization/UpgradeBadge';
import { openPricingModal } from '../utils/url/pricingPath';
import SettingsSection from './SettingsSection';
import * as styles from './SettingsSectionUpsell.module.scss';

interface SettingsSectionUpsellProps {
  header?: string;
  feature?: PlanFeatureKey;
  description: string;
  contentCards: React.ReactNode;
}

const SettingsSectionUpsell = ({
  header,
  feature,
  description,
  contentCards,
}: SettingsSectionUpsellProps) => {
  const dispatch = useAppDispatch();

  return (
    <SettingsSection
      header={
        header && (
          <div className={styles.header}>
            {header}
            <div className={styles.headerUpgradeButton}>
              <UpgradeBadge
                onClick={() => {
                  openPricingModal(dispatch, feature);
                }}
              />
            </div>
          </div>
        )
      }
    >
      <Card noPadding>
        <div className={styles.contentWrapper}>
          <div className={styles.description}>{description}</div>
          <div className={styles.cardsWrapper}>
            <div className={styles.cards}>{contentCards}</div>
          </div>
          <PricingModalButton feature={feature}>
            View upgrade options
          </PricingModalButton>
        </div>
      </Card>
    </SettingsSection>
  );
};

export default SettingsSectionUpsell;
